import React from 'react'
import { useParams } from 'react-router-dom'
import HeaderOne from '../Components/Header/HeaderOne'
import Breadcrumb from '../Components/BreadCrumb/Breadcrumb'
import BlogDetailsMain from '../Components/Blog/BlogDetailsMain'
import FooterFour from '../Components/Footer/FooterFour'
import ScrollToTop from '../Components/ScrollToTop'
import { api } from '../services/api'
import { usePageBanner } from '../hooks/usePageBanner'

function BlogDetails() {
    const { id } = useParams()
    const { title, bgImage } = usePageBanner({
        itemLoader: api.getBlogPost,
        itemId: id,
        fallbackTitle: 'Blog Details',
    })

    return (
        <>
            <HeaderOne />
            <Breadcrumb title={title} bgImage={bgImage} />
            <BlogDetailsMain />
            <FooterFour />
            <ScrollToTop />
        </>
    )
}

export default BlogDetails
